export const USER = 'USER';
export const CUSTOM = 'CUSTOM';
export const CUSTOM_ADDRESS = 'CUSTOM';
export const MERGE_TAG = 'MERGE_TAG';
export const CONNECTED_ACCOUNTS = 'CONNECTED_ACCOUNTS';